import { useState } from "react";
import axios from "axios";
import config from "../../../Helpers/config.json";
import { convertDate } from "../../../Utils/titleCaseFunction";

export function useDynamicExcelExport(actions) {
  const [loading, setLoading] = useState("idle");
  const current_date = convertDate();

  const exportExcelDynamic = ({ url, file_name, params = {} } = {}) => {
    if (!url || !file_name) return;

    setLoading("loading");

    axios
      .get(`${config.epharmUrl}/${url}`, { params, responseType: "blob" })
      .then((response) => {
        const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = blobUrl;
        link.setAttribute("download", `${file_name}_Report_${current_date}.xlsx`);
        document.body.appendChild(link);
        link.click();
        setLoading("success");
      })
      .catch((err) => {
        setLoading("error");
        console.error(err);
      });
  };

  return {
    exportExcelDynamic,
    isLoading: loading === "loading",
    isSuccess: loading === "success",
    isError: loading === "error",
  };
}
export function useDynamicPdfExport(actions) {
  const [loading, setLoading] = useState("idle");
  const current_date = convertDate();

  const exportPdfDynamic = ({ url, file_name, params = {} } = {}) => {
    if (!url || !file_name) return;

    setLoading("loading");

    axios
      .get(`${config.epharmUrl}/${url}`, { params, responseType: "blob" })
      .then((response) => {
        const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = blobUrl;
        link.setAttribute("download", `${file_name}_Report_${current_date}.pdf`);
        document.body.appendChild(link);
        link.click();
        setLoading("success");
      })
      .catch((err) => {
        setLoading("error");
        console.error(err);
      });
  };

  return {
    exportPdfDynamic,
    isLoading: loading === "loading",
    isSuccess: loading === "success",
    isError: loading === "error",
  };
}
